import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column gap-4" }

import SectionItem from './SectionItem.vue'
import type { ISection } from './learningPath';


export default /*#__PURE__*/_defineComponent({
  props: {
    sections: null,
    pathwayId: null,
    openSectionIds: null,
    currentResourceId: null
  },
  emits: ["toggle"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'toggle', sectionId: number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  sections: ISection[]
  pathwayId: string
  openSectionIds: number[]
  currentResourceId: number | null
}





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.sections, (section, index) => {
      return (_openBlock(), _createBlock(SectionItem, {
        key: section.id,
        section: section,
        number: index + 1,
        "pathway-id": props.pathwayId,
        open: props.openSectionIds.includes(section.id),
        "current-resource-id": props.currentResourceId,
        onToggle: ($event: any) => (emit('toggle', section.id))
      }, null, 8, ["section", "number", "pathway-id", "open", "current-resource-id", "onToggle"]))
    }), 128))
  ]))
}
}

})